module.exports = __webpack_public_path__ + "img/rent-protection.5f92417c.png";